import { render, staticRenderFns } from "./clientStatement.vue?vue&type=template&id=43a7bdda"
import script from "./clientStatement.vue?vue&type=script&lang=js"
export * from "./clientStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports